export type DocumentType = 'pdf' | 'word' | 'excel' | 'text' | 'html' | 'markdown';

export const SUPPORTED_FILE_EXTENSIONS: Record<DocumentType, string[]> = {
  pdf: ['pdf'],
  word: ['doc', 'docx'],
  excel: ['xls', 'xlsx'],
  text: ['txt'],
  html: ['html', 'htm'],
  markdown: ['md', 'markdown']
};

export const FILE_TYPE_DISPLAY_NAMES: Record<DocumentType, string> = {
  pdf: 'PDF',
  word: 'Word',
  excel: 'Excel',
  text: 'Text',
  html: 'HTML',
  markdown: 'Markdown'
};

export const getDocumentTypeFromExtension = (extension: string): DocumentType | undefined => {
  const normalizedExt = extension.toLowerCase();
  for (const [type, extensions] of Object.entries(SUPPORTED_FILE_EXTENSIONS)) {
    if (extensions.includes(normalizedExt)) {
      return type as DocumentType;
    }
  }
  return undefined;
};

export const getAllSupportedExtensions = (): string[] => {
  return Object.values(SUPPORTED_FILE_EXTENSIONS).flat();
};

export const getAcceptString = (): string => {
  return getAllSupportedExtensions()
    .map(ext => `.${ext}`)
    .join(',');
}; 